export default __webpack_public_path__ + "static/media/WhereAreYouFrom_22.862240a5.png";